import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

export interface Iprops {
  to: string
  from?: string
}
/**
 * TODO: 与Redirect的uri功能一样，可以剔除这个
 * @param props
 * @returns
 */
const RedirectWithQuery: React.FC<Iprops> = (props) => {
  const { to } = props
  const location = useLocation()
  const query = location.search
  const path = `${to}${query}`
  return <Redirect to={path} />
}
RedirectWithQuery.displayName = 'RedirectWithQuery'
export default RedirectWithQuery
